import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactResizeDetector from 'react-resize-detector';
import { Portal, PortalWithState } from 'react-portal';

import CloseIcon from 'Assets/images/icon_close.svg';
import './Product.module.css';

/*
Product.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    shortdescription: PropTypes.string,
    description: PropTypes.string,
    profile: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
    })),
    attributes: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
    })),
  }).isRequired,
}; */

class Product extends Component {

  state = {
      boxWidth: 200
  };

  componentDidMount = () => {
    console.log("Component did mount");

  }

  onResize = (width) => {
    console.log("onResize: " + width);
    this.setState({ boxWidth: width});
  }

  openPopup = (openPortalFn) => {
    const fakeEvent = {
      nativeEvent: {
        stopImmediatePropagation: () => {},
      },
    };
    setTimeout(() => openPortalFn(fakeEvent), 0);
  }

  render() {
    const { data } = this.props;
    return (
          <div styleName="Product"
               onClick={ (e) => { this.props.onClick(data); e.stopPropagation(); e.preventDefault(); }}
               ref={(el) => { this.el = el;}}
          >
            <div style={{width: this.props.width, height: this.props.width}}>
            <div styleName="ContentContainer">
              <div styleName="BorderContainer">
                <span styleName="name">{data.name}</span><br/>
                <span styleName="additionalName">{data.additionalName}</span>
                <span styleName="brand">{data.brand}{ data.brand === 'Montadrill' ? '®' : ''}</span>
              </div>
            </div>
            </div>
          </div>
    );
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Products/Product.js